import { connect } from 'react-redux'
import Viewer from './Viewer'

const mapStateToProps = state => ({})

export default connect(
  mapStateToProps
)(Viewer)



// WEBPACK FOOTER //
// ./src/views/Viewer/index.js